/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolVideogameAssetIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-videogame-asset"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.88 18.7Q2.77 18.7 2 17.93Q1.23 17.15 1.23 16.05L1.23 7.9Q1.23 6.8 2 6.03Q2.77 5.25 3.88 5.25L20.18 5.25Q21.27 5.25 22.05 6.03Q22.82 6.8 22.82 7.9L22.82 16.05Q22.82 17.15 22.05 17.93Q21.27 18.7 20.18 18.7ZM6.63 13.3L6.63 13.4Q6.63 13.95 7.01 14.34Q7.4 14.72 7.95 14.72Q8.5 14.72 8.89 14.34Q9.28 13.95 9.28 13.4L9.28 13.3L9.38 13.3Q9.93 13.3 10.31 12.91Q10.7 12.53 10.7 11.97Q10.7 11.43 10.31 11.04Q9.93 10.65 9.38 10.65L9.28 10.65L9.28 10.55Q9.28 10 8.89 9.61Q8.5 9.22 7.95 9.22Q7.4 9.22 7.01 9.61Q6.63 10 6.63 10.55L6.63 10.65L6.53 10.65Q5.97 10.65 5.59 11.04Q5.2 11.43 5.2 11.97Q5.2 12.53 5.59 12.91Q5.97 13.3 6.53 13.3ZM14.35 14.75Q14.35 14.75 14.66 14.75Q14.97 14.75 15.41 14.31Q15.85 13.88 15.85 13.25Q15.85 12.63 15.41 12.19Q14.97 11.75 14.35 11.75Q13.72 11.75 13.29 12.19Q12.85 12.63 12.85 13.25Q12.85 13.88 13.29 14.31Q13.72 14.75 14.35 14.75ZM17.35 12.22Q17.35 12.22 17.66 12.22Q17.98 12.22 18.41 11.79Q18.85 11.35 18.85 10.72Q18.85 10.1 18.41 9.66Q17.98 9.22 17.35 9.22Q16.73 9.22 16.29 9.66Q15.85 10.1 15.85 10.72Q15.85 11.35 16.29 11.79Q16.73 12.22 17.35 12.22Z" fill={color} />
    </svg>
  );
}
